import React from 'react';
import { Dialog, Image, T } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import IconFullScreenExpand from '@static/images/icon_fullscreen_expand.svg';
import styles from './FullScreenMembershipDialog.module.scss';
export function FullScreenMembershipDialog({ open, onClose, onConfirm }) {
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.fullScreen.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.image,
        image: {
            src: IconFullScreenExpand,
            alt: emptyTranslation
        }
    }), /*#__PURE__*/ React.createElement("p", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.fullScreen.body'
        }
    })))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onConfirm
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.fullScreen.checkButton'
        }
    }))));
}
